import { NavLink, useLocation } from 'react-router-dom';

const INVENTORY_NAV_TABS = [
  { id: 'inventory', label: 'Inventory Master', path: '/masters/inventory/list' },
  { id: 'inventory-group', label: 'Inventory Group', path: '/masters/inventory-group/list' },
];

export default function InventorySubNav() {
  const location = useLocation();

  function isTabActive(tab) {
    if (tab.id === 'inventory-group') {
      return location.pathname.includes('/inventory-group');
    }
    if (tab.id === 'inventory') {
      return location.pathname.includes('/inventory/') || location.pathname === '/masters/inventory/list';
    }
    return false;
  }

  return (
    <nav
      className="flex max-w-full shrink-0 items-center gap-1.5 overflow-x-auto rounded-2xl bg-surface-container-low p-1.5 app-hide-scrollbar"
      aria-label="Inventory Navigation Tabs"
    >
      {INVENTORY_NAV_TABS.map((tab) => {
        const active = isTabActive(tab);
        return (
          <NavLink
            key={tab.id}
            to={tab.path}
            className={`whitespace-nowrap rounded-xl px-4 py-2 text-xs font-bold transition-all ${
              active
                ? 'bg-surface-container-lowest text-primary shadow-sm ring-1 ring-primary/10'
                : 'text-on-surface-variant hover:bg-surface-container-high/60 hover:text-on-surface'
            }`}
          >
            <span>{tab.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
